import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { createSelector } from 'reselect';
import PropTypes from 'prop-types';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { presetService } from '../../../../services/preset-service';
import Global from '../../../../store/global-selectors';
import messages from './messages';

export const selectMappedPresetOptions = createSelector(
  [Global.selectSellerPresets, Global.selectSellerPackages, Global.selectSellerServices, Global.selectSellerLabelProviders],
  (presets, packages, services, sellerLabelProviders) => {
    const mappedPresets = presets.map((preset) => presetService.mapPresetToKeyValue(preset, packages, services, sellerLabelProviders));
    return mappedPresets;
  },
);

// TODO: possibly extract this out generically
export const BulkPresetDropdown = ({ className = '', onPresetSelected, selectedPresetId }) => {
  const sellerShipFroms = useSelector(Global.selectSellerShipFroms);
  const presets = useSelector(selectMappedPresetOptions);

  const formattedPresets = useMemo(() => presets.map((preset) => ({ value: preset.presetId, text: preset.name })), [presets]);
  const selectedPreset = useMemo(
    () => formattedPresets.find((preset) => preset.value === selectedPresetId),
    [formattedPresets, selectedPresetId],
  );

  const onClick = useCallback(
    (presetId) => {
      const matchingPreset = presets.find((preset) => preset.presetId === presetId);
      onPresetSelected(matchingPreset, sellerShipFroms);
    },
    [onPresetSelected, presets, sellerShipFroms],
  );

  return (
    <DropdownMenu className={className} dropdownMenuShouldHaveWidthOfButton value={selectedPreset?.value} variant='form'>
      <DropdownMenuToggler>{selectedPreset?.text ?? <FormattedMessage {...messages.defaultTitle} />}</DropdownMenuToggler>
      {formattedPresets.map((option) => (
        <DropdownMenuItem key={option.value} name={option.value} onClick={onClick} selected={selectedPreset?.value === option.value}>
          {option.text}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

BulkPresetDropdown.propTypes = {
  className: PropTypes.string,
  selectedPresetId: PropTypes.string,
  onPresetSelected: PropTypes.func.isRequired,
};

export default BulkPresetDropdown;
